// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n.modify-batch-order .el-dialog__body {\n  padding-top: 10px;\n}\n.modify-batch-order .hander-batch {\n  height: 28px;\n  margin-bottom: 10px;\n  text-align: right;\n}\n.modify-batch-order .nb-table {\n  margin-bottom: 20px;\n}\n.modify-batch-order .btn-box {\n  text-align: center;\n}", ""]);
// Exports
exports.locals = {
	"theme": "#30B08F",
	"menuBg": "#304156",
	"menuText": "#bfcbd9",
	"menuActiveText": "#409EFF"
};
module.exports = exports;
